import { render, staticRenderFns } from "./KnowledgeVideo.vue?vue&type=template&id=6a251392&scoped=true&"
import script from "./KnowledgeVideo.vue?vue&type=script&lang=js&"
export * from "./KnowledgeVideo.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeVideo.vue?vue&type=style&index=0&id=6a251392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a251392",
  null
  
)

export default component.exports